// extracted by mini-css-extract-plugin
export default {"rivers":"FeaturesSection-module__rivers__uv3LX8O"};